<template>
  <div id="componente-captura">
    <div class="delimitador-captura hidden" id="delimitador-captura">
      <div class="dl1"></div>
      <div class="dl2"></div>
    </div>
    <div class="moldura-verde-transparente" id="moldura-verde-transparente"></div>
    <div class="texto-captura-doc d-flex align-items-center justify-content-center  hidden" id="texto-captura-doc">
      <p class="txt-titulo"></p>
    </div>
    <div id="documento" ></div>
  </div>
</template>

<script>

export default {
  name: "DocCaptura",
  data:function (){
    return {
      textos_moldura_sucesso:[
        "estamostirandoafotomantenhaocelularnestaposição",
        "pronto!tiramosafotoaguardeavalidaçãododocumento"
      ]
    }
  },
  props:{
    texto: {type: String},
  },
  watch: {
    texto:function (val){
      this.aleraMoldura(val);
      this.adicionaTexto(val);
    }
  },
  methods:{
    adicionaTexto:function (valor){
      $('.backgraund-shape').find('.texto-captura-doc p').html(valor);
    },
    aleraMoldura:function (valor){
      let v = valor
          .toLowerCase()
          .trim()
          .replace(/<[^>]*>/g,'')
          .replace(/\s+/g,'');
      let $moldura = $('.delimitador-captura');
      if(this.textos_moldura_sucesso.includes(v)){
        $moldura.addClass('moldura-nova-capturando');
        return;
      }
      $moldura.removeClass('moldura-nova-capturando');
    }
  }
}
</script>

<style scoped>
.hidden{
  display: none;
}
.txt-titulo{
  font-size: 1.125rem;
  color: rgba(0, 0, 0, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/DocCaptura.vue